import { ApiClient } from './api-client';
import { config } from 'packages/config';

const apiClient = new ApiClient(config.ENV.API.EVERBEAT_BASE_URL);

export { apiClient };
